import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
interface NowMintingStatsItemProps {
  readonly label: ReactNode;
  readonly value?: ReactNode;
  readonly status?: "active" | "upcoming" | "ended" | undefined;
  readonly isLoading?: boolean;
  readonly allowWrap?: boolean;
}
export default function NowMintingStatsItem(t0) {
  const $ = _c(12);
  const {
    label,
    value,
    status,
    isLoading,
    allowWrap
  } = t0;
  let t1;
  if ($[0] !== status) {
    t1 = () => {
      if (status === "active") {
        return "tw-text-emerald-400";
      }
      if (status === "ended") {
        return "tw-text-iron-400";
      }
      return "tw-text-iron-100";
    };
    $[0] = status;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getValueColor = t1;
  let t2;
  if ($[2] !== label) {
    t2 = <span className="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wider tw-text-iron-400">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== allowWrap || $[5] !== getValueColor || $[6] !== isLoading || $[7] !== value) {
    t3 = isLoading ? <span className="tw-h-6 tw-w-20 tw-animate-pulse tw-rounded tw-bg-iron-800" /> : <span className={`tw-font-mono tw-text-sm tw-font-medium md:tw-text-base ${getValueColor()} ${allowWrap ? "tw-whitespace-normal" : "tw-whitespace-nowrap"}`}>{value}</span>;
    $[4] = allowWrap;
    $[5] = getValueColor;
    $[6] = isLoading;
    $[7] = value;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-gap-1.5">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}